<template lang="html">
  <button
    class="btn-rounded"
    type="button"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <uhv-svg-icon icon="bars" />
  </button>
</template>

<script>
  import UHVSvgIcon from '@/components/svg/UHVSvgIcon'

  export default {
    name: 'UHVBarsButton',
    components: {
      'uhv-svg-icon': UHVSvgIcon
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
